import React, { Suspense, lazy, useEffect, useState } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  redirect,
  Outlet,
} from "react-router-dom";
import { AppProvider } from '../data/context.tsx';
import { useSelector } from "react-redux";
import SuitabilityCalculation from "../components/site-suitablity-calculation/SuitabalityCalculation.jsx";
import Register from "../components/registration/Register.jsx";
import Start from "../pages/start/start.tsx";
import Welcome from "../pages/welcome/welcome.tsx";
import GoalSetting from "../pages/goalSetting/goalSetting.tsx";
import BusinessModel from "../pages/businessModels/businessModels.tsx";
import PlantLocation from "../pages/plantLocation/plantLocation.tsx";
import MCDAResults from "../pages/mcdaResults/mcdaResults.tsx";
import AuthHeader from "../components/authHeader/AuthHeader.tsx";

const GlobalLayout = () => (
  <>
    <AuthHeader />
    <Outlet />
  </>
);

const Login = lazy(() => import("../components/login/login.tsx"));
const Home = lazy(() => import("../components/home/Home.jsx"));
const SpatialQuery = lazy(() =>
  import("../components/spatial-query/SpatialQuery.jsx")
);
const TestComponentPage = lazy(() => import("../pages/TestComponentPage.tsx"));

const AppRouter = () => {
  const logInDeatils = useSelector((state) => state.auth.isLoggedIn);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    setIsLoggedIn(logInDeatils);
  }, [logInDeatils]);

  const router = createBrowserRouter([
    {
      element: <GlobalLayout />,
      children: [
        {
          path: "/start",
          element: (
            <Suspense fallback={<div>Loading Sign In...</div>}>
              <Start />
            </Suspense>
          ),
          loader: () => {
            if (isLoggedIn) {
              return redirect("/");
            }
            return null;
          },
        },
        {
          path: "/goal-setting",
          element: (
            <Suspense fallback={<div>Goal-setting Loading ...</div>}>
              <GoalSetting />
            </Suspense>
          )
        },
        {
          path: "/welcome",
          element: (
            <Suspense fallback={<div>Welcome Loading ...</div>}>
              <Welcome />
            </Suspense>
          )
        },
        {
          path: "/business-model",
          element: (
            <Suspense fallback={<div>Business-model Loading ...</div>}>
              <BusinessModel />
            </Suspense>
          )
        },
        {
          path: "/plant-location",
          element: (
            <Suspense fallback={<div>Plant-location Loading ...</div>}>
              <PlantLocation />
            </Suspense>
          )
        },
        {
          path: "/mcda-results",
          element: <MCDAResults />
        },
        {
          path: "/testcomp",
          element: (
            <Suspense fallback={<div>Loading Test Page...</div>}>
              <TestComponentPage />
            </Suspense>
          )
        },
        {
          path: "/login",
          element: (
            <Suspense fallback={<div>Loading Sign In...</div>}>
              <Login />
            </Suspense>
          ),
          loader: () => {
            if (isLoggedIn) {
              return redirect("/");
            }
            return null;
          },
        },
        {
          path: "/register",
          element: (
            <Suspense fallback={<div>Loading Registration...</div>}>
              <Register />
            </Suspense>
          ),
        },
        {
          path: "/",
          element: (
            <Suspense fallback={<div>Loading Layout...</div>}>
              <Welcome />
            </Suspense>
          ),
          loader: () => {
            if (!isLoggedIn) {
              return redirect("/start");
            }
            return null;
          },
          children: [
            {
              index: true,
              element: (
                <Suspense fallback={<div>Loading Home...</div>}>
                  <Home />
                </Suspense>
              ),
              loader: () => {
                if (!isLoggedIn) {
                  return redirect("/start");
                }
                return null;
              },
            },
            {
              path: "/suitability-analysis/:id",
              element: (
                <Suspense fallback={<div>Loading ...</div>}>
                  <SuitabilityCalculation />
                </Suspense>
              ),
              loader: () => {
                if (!isLoggedIn) {
                  return redirect("/start");
                }
                return null;
              },
            },
            {
              path: "spatial-query",
              element: (
                <Suspense fallback={<div>Loading Spatial Query...</div>}>
                  <SpatialQuery />
                </Suspense>
              ),
              loader: () => {
                if (!isLoggedIn) {
                  return redirect("/start");
                }
                return null;
              },
            },
          ],
        },
      ]
    }
  ]);

  return (
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  );
};

export default AppRouter;
